export default __webpack_public_path__ + "static/illustration-content-logo.url-855d3631ddb8be77d6f6b1de36d81a2f.svg";